module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Collection of Sand: Essays")]), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "EB04MainHead",
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("A Note on the Text")]), _vm._v(" "), _c('p', {
    staticClass: "EB02BodyTextFullOut",
    attrs: {
      "id": "col0000086"
    }
  }, [_vm._v("The essays in parts I, II and III were all\n\t\t\tpublished in "), _c('em', [_vm._v("la Repubblica")]), _vm._v(" between 1980 and 1984, apart from the following:\n\t\t\t‘Collection of Sand’ ("), _c('em', [_vm._v("Corriere della Sera")]), _vm._v(", 25 June 1974);\n\t\t\t‘How New the New World Was’ (a spoken commentary for broadcast by RAI-TV,\n\t\t\tDecember 1976); ‘The Encyclopedia of a Visionary’ ("), _c('em', [_vm._v("FMR")]), _vm._v(", vol. I,\n\t\t\tMarch 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "EB03BodyTextIndented",
    attrs: {
      "id": "col0000087"
    }
  }, [_vm._v("The fourth part, ‘The Shape of\n\t\t\tTime’, includes pieces on Japan and Mexico, from 1976, partly published in\n\t\t\t\t"), _c('em', [_vm._v("Corriere della Sera")]), _vm._v(" and partly unpublished, and passages on Iran that have\n\t\t\tnever been published before, from notes made during a journey there in 1975.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0080a47e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/noteontext.vue
// module id = 69
// module chunks = 0